import * as angular from "angular";
import type { ControlState } from "./control-state";
import template from "./boolean-control.html";
import confirmClear from "../../../behaviors/confirm-clear";
import "./boolean-control.less";

export interface BooleanControlController {
	control: ControlState;
}

// AngularJS owns the merged binding properties.
// eslint-disable-next-line no-redeclare
export class BooleanControlController implements angular.IController {
	public readonly choices = [
		{
			value: true,
			label: "Yes"
		},
		{
			value: false,
			label: "No"
		}
	];

	public select(value: boolean): void {
		if(this.control.canEdit()) {
			this.control.change(value);
		}
	}

	public clear(): void {
		if(this.control.canEdit() && this.control.value !== undefined) {
			this.control.change(undefined);
		}
	}
}

export default angular.module("vesl.extensions.json-schema.boolean-control", [confirmClear])
	.component("jsonSchemaBooleanControl", {
		template,
		controller: BooleanControlController,
		bindings: { control: "<" }
	})
	.name;
